// extracted by mini-css-extract-plugin
export default {"wrapper":"SoundCloudPlayer_wrapper__cb7Im","fadeIn":"SoundCloudPlayer_fadeIn__uWGJ+","loader":"SoundCloudPlayer_loader__3LNw5"};